import {LocationURIs} from "../core/app_conf";

const DYNATRACE_SCRIPT_ID = 'dynatrace-script';

// Fill these values with your Dynatrace base URL and per-environment script names.
const DYNATRACE_SCRIPT_BASE_URL = 'https://js-cdn.dynatrace.com/jstag/178881c0ab8/bf17498jmb/';

export const getDynatraceScriptUrl = (): string => {
    let DYNATRACE_SCRIPT_NAME: string | undefined;
    switch (window.location.host) {
        case LocationURIs.AZURE_PROD:
        case LocationURIs.AZURE_PROD_CUS:
        case LocationURIs.AZURE_PROD_EU2:
            DYNATRACE_SCRIPT_NAME = '76608b48582993bf_complete.js';
            break;
        case LocationURIs.AZURE_DEV:
            DYNATRACE_SCRIPT_NAME = 'd43c19253b8d6aec_complete.js';
            break;
        case LocationURIs.AZURE_QA:
        case LocationURIs.AZURE_QA_CUS:
        case LocationURIs.AZURE_QA_EU2:
            DYNATRACE_SCRIPT_NAME = '44bda50a42a10521_complete.js';
            break;
        case LocationURIs.AZURE_UAT:
            DYNATRACE_SCRIPT_NAME = 'f971a6b2c2809357_complete.js';
            break;
        default:
            DYNATRACE_SCRIPT_NAME = 'd43c19253b8d6aec_complete.js';
            break;
    }

    return `${DYNATRACE_SCRIPT_BASE_URL}${DYNATRACE_SCRIPT_NAME}`;
};

// Loads Dynatrace script once per page load and ignores repeated calls.
export const loadDynatraceScript = (): void => {

    if (document.getElementById(DYNATRACE_SCRIPT_ID)) {
        return;
    }

    const script = document.createElement('script');
    script.id = DYNATRACE_SCRIPT_ID;
    script.src = getDynatraceScriptUrl();
    script.async = true;
    script.type = 'text/javascript';

    document.head.appendChild(script);
};

export { DYNATRACE_SCRIPT_ID };
